import { type MantineColor, Text } from "@mantine/core";
import { useMemo } from "react";

import { ClockIcon, TriangleIcon } from "../ChatAlertBanner/icons";
import { TypingEllipsis } from "../ChatMessages/TypingEllipsis";
import { ChatPreviewBadge } from "./ChatPreviewBadge";
import { CountdownTimer } from "./CountdownTimer";

export const AboutToEnd = ({
    endReason,
    endAt,
    endReasonColor,
}: {
    endReason: string;
    /** Unix timestamp in milliseconds */
    endAt: number | undefined;
    endReasonColor: MantineColor;
}) => {
    const iconColor = "var(--mantine-color-dark-9)";
    const leftIcon = useMemo(() => {
        if (endReason === "Neglected") {
            return <TriangleIcon size={8} fillColor={iconColor} />;
        } else if (endReason === "Inactive") {
            return <ClockIcon size={8} fillColor={iconColor} />;
        } else {
            return null;
        }
    }, [endReason]);

    return (
        <>
            {endReason !== "Chat ended" && (
                <ChatPreviewBadge
                    color={endReasonColor}
                    c="dark.9"
                    h="var(--mantine-spacing-sm)"
                    leftSection={leftIcon}
                >
                    {endReason === "Neglected" && endAt && <CountdownTimer endAt={endAt} />}
                    {endReason === "Inactive" && <Text size="xxs">{endReason}</Text>}
                </ChatPreviewBadge>
            )}
            {endReason === "Chat ended" && (
                <Text size="xxs" c="dark.2">
                    <span>Closing chat</span>
                    <TypingEllipsis />
                </Text>
            )}
        </>
    );
};
